export default __webpack_public_path__ + "static/media/settings.e9633a0f.svg";